module.exports = __webpack_public_path__ + "img/logo.1c9b3456.png";